export default __webpack_public_path__ + "static/media/green.af311854.pdf";